import React, { useState, useEffect } from "react";
import GeradorQrCode from "./Includes/GeradorQrCode";
import Navbar from "./Includes/Navbar";
import Institucional from "./Includes/Institucional";
import Modal from "./Includes/Modal";
import Footer from "./Includes/Footer";
import useModal from "../hooks/useModal";
import ConsentModal from "./Includes/ConsentModal";

function Home() {
    const { isModalOpen, toggleModal } = useModal();
    const [isConsentModalOpen, setIsConsentModalOpen] = useState(false);

    useEffect(() => {
        const consentGiven = localStorage.getItem('consentGiven');
        if (!consentGiven) {
            setIsConsentModalOpen(true);
        }
    }, []);

    const handleAccept = () => {
        window.gtag('consent', 'update', {
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
        localStorage.setItem('consentGiven', 'true');
        setIsConsentModalOpen(false);
    };

    const handleDeny = () => {
        window.gtag('consent', 'update', {
            'ad_storage': 'denied',
            'analytics_storage': 'denied'
        });
        localStorage.setItem('consentGiven', 'true');
        setIsConsentModalOpen(false);
    };

    return (
        <>
            <Navbar />
            <GeradorQrCode toggleModal={toggleModal} />
            <Institucional toggleModal={toggleModal} />
            <Modal isOpen={isModalOpen} toggleModal={toggleModal} />
            <Footer />
            <ConsentModal isOpen={isConsentModalOpen} onAccept={handleAccept} onDeny={handleDeny} />
        </>
    );
}

export default Home;